import { faInstagram, faTelegram, faWhatsapp } from '@fortawesome/free-brands-svg-icons'
import { faEnvelope, faPhone } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import Style from './ContactUs.module.css'
const ContactUs = () => {
    return (
        <div className={Style.ComponentHolder}>
            <div className={Style.ImageHolder}><img src="/Assets/Images/Regular/contactus.png" alt="contactUs" /></div>
            <div></div>
            <div className={Style.socialHolder}>
                <div className={Style.socialPart}>
                <a href="https://www.instagram.com/electronicsteps" rel='noreferrer' target="_blank" className={Style.instagram}>
                    <FontAwesomeIcon icon={faInstagram}/>
                </a>
                <p style={{background: 'linear-gradient(to top left,#F09433,#E6683C,#DC2743,#5014C9)'}}>@Electronicsteps</p>
                </div>
                <div className={Style.socialPart}>
                    <a href="https://t.me/electronicsteps" rel='noreferrer' target="_blank" className={Style.telegram}>
                        <FontAwesomeIcon icon={faTelegram}/>
                    </a>
                    <p style={{background: '#0088CC'}}>@Electronicsteps</p>     
                </div>
                <div className={Style.socialPart}>
                    <a href="https://wa.me/989111555313" rel='noreferrer' target="_blank" className={Style.whatsapp}>
                        <FontAwesomeIcon icon={faWhatsapp}/>
                    </a>
                    <p style={{background: '#25D366'}}>0 911 155 5313</p>     
                </div>
                <div className={Style.socialPart}>
                    <a href="tel:09111555313"  className={Style.phoneCall}>
                        <FontAwesomeIcon icon={faPhone}/>
                    </a>
                    <p style={{background: '#cccccc'}}>01134521323</p>     
                </div>
                <div className={Style.socialPart}>
                    <a href="mailto:mb.forouqi@gmail.com"  className={Style.email}>
                        <FontAwesomeIcon icon={faEnvelope}/>
                    </a>
                    <p style={{background: '#ff6666'}}>mb.forouqi@gmail.com</p>     
                </div>
            </div>
        </div>
    )
}

export default ContactUs
